import { render, staticRenderFns } from "./insulfilm-protecao-solar-janela.vue?vue&type=template&id=3f05f8ae&"
import script from "./insulfilm-protecao-solar-janela.vue?vue&type=script&lang=js&"
export * from "./insulfilm-protecao-solar-janela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports